import {Center} from '~/components/Center';
import {Paragraph} from '~/components/Paragraph';
import {Title} from '~/components/Title';
import {SectionQuote} from './SectionQuoute';
import {TitleSection} from '~/components/TitleSection';
import {HorizontalDivider} from '~/components/HorizontalDivider';
import {useTranslation} from 'react-i18next';
import {ProductsSlider} from '../../components/ProductsSlider';
import {ProductsPageData} from '../../services/GetProductsPageService';
import {ImageHeader} from '~/features/shared';

interface ProductsPageProps {
  data: ProductsPageData;
}

export function ProductsPage({data}: ProductsPageProps) {
  const {t} = useTranslation();

  const page = data.page;
  const basePage = data.basePage;

  return (
    <>
      <Center className="w-full lg:px-20 lg:pt-10">
        <ImageHeader
          image={basePage.headerImage}
          breadcrumb={[
            {
              title: t('inicio'),
              to: '/',
            },
            {
              title: t('productos'),
            },
          ]}
          title={t('productos')}
        />
      </Center>

      <Center className="mb-16 lg:px-20">
        <section className="flex flex-col gap-8 items-center px-5 sm:px-10 md:flex-row md:items-start">
          <div className="flex-1">
            <TitleSection i18nKey="pages:productos:title.0" className="mb-4" />

            <Title
              i18nKey="pages:productos:title.1"
              className="mb-6 text-2xl leading-normal sm:text-4xl"
            />

            <Paragraph i18nKey="pages:productos:content" />
          </div>

          <img
            className="object-cover bg-black rounded-3xl"
            width={300}
            height={300}
            style={{
              width: 300,
              height: 300,
            }}
            src={page.image1?.image.url}
            alt={page.image1?.image.altText}
            loading="eager"
          />
        </section>
      </Center>

      <section className="mb-16">
        <Center className="px-5 mb-8 sm:px-10 md:mb-16 lg:px-30">
          <Title
            id="pantallas-de-exterior"
            i18nKey="pantallas-de-exterior"
            className="mb-6 text-2xl leading-normal sm:text-4xl"
          />

          <Paragraph i18nKey="pages:productos:pantallas-de-exterior" />
        </Center>

        <ProductsSlider items={page.pantallasExterior} />
      </section>

      <section className="mb-16">
        <Center className="px-5 mb-8 sm:px-10 md:mb-16 lg:px-30">
          <Title
            id="pantallas-de-interior"
            i18nKey="pantallas-de-interior"
            className="mb-6 text-2xl leading-normal sm:text-4xl"
          />

          <Paragraph i18nKey="pages:productos:pantallas-de-interior" />
        </Center>

        <ProductsSlider items={page.pantallasInterior} />
      </section>

      <section>
        <Center className="px-5 mb-8 sm:px-10 md:mb-16 lg:px-30">
          <Title
            id="hibridos"
            i18nKey="hibridos"
            className="mb-6 text-2xl leading-normal sm:text-4xl"
          />
          <Paragraph i18nKey="pages:productos:hibridos" />
        </Center>

        <ProductsSlider items={page.hibridos} />
      </section>

      <Center className="px-5 sm:px-10 lg:px-30">
        <HorizontalDivider />

        <SectionQuote image={basePage.cotizarImage} />
      </Center>
    </>
  );
}
